import ForgetPassword from "../../../jsx/pages/ForgotPassword";

const LoginWrapper = function (props) {
  return <ForgetPassword />;
};

export default constore(LoginWrapper);
